var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"form-card pay-card-container"},[_c('div',[_c('h4',{staticClass:"form-card-header"},[_vm._v(_vm._s(_vm.$t('payment.title')))]),_c('p',{staticClass:"form-card-description"},[_vm._v(_vm._s(_vm.$t('payment.description')))])]),_c('div',{staticClass:"pay-card-table"},[_c('account-info-table')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }